import React, { useState } from 'react';
import { Carousel } from 'react-bootstrap';
import AnimatedSection from '../../components/AnimatedSection';
import './HomePage.css';

const HomePage: React.FC = () => {
  const [index, setIndex] = useState(0);

  const visionItems = [
    {
      id: 1,
      title: "Wedding Photography",
      description: "Captured beautiful moments from over 200+ weddings, creating timeless memories with artistic composition and emotional storytelling.",
      image: "/home_1.jpg",
      icon: "M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"
    },
    {
      id: 2,
      title: "Portrait Sessions",
      description: "Professional portrait photography for individuals, families, and corporate clients, showcasing personality and character through expert lighting.",
      image: "/home_1.jpg",
      icon: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
    },
    {
      id: 3,
      title: "Event Photography",
      description: "Documented corporate events, parties, and special occasions with dynamic coverage and professional post-processing for lasting memories.",
      image: "/home_1.jpg",
      icon: "M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"
    },
    {
      id: 4,
      title: "Commercial Photography",
      description: "High-quality commercial photography for brands, products, and marketing campaigns that capture attention and drive engagement.",
      image: "/home_1.jpg",
      icon: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
    },
    {
      id: 5,
      title: "Fashion Photography",
      description: "Creative fashion photography that showcases style, elegance, and personality through innovative concepts and artistic vision.",
      image: "/home_1.jpg",
      icon: "M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"
    },
    {
      id: 6,
      title: "Real Estate Photography",
      description: "Professional real estate photography that highlights property features and creates compelling visual narratives for listings.",
      image: "/home_1.jpg",
      icon: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
    }
  ];

  const handleSelect = (selectedIndex: number) => {
    setIndex(selectedIndex);
  };

  // Chia items thành các slide, mỗi slide 3 items
  const slides = [];
  for (let i = 0; i < visionItems.length; i += 3) {
    slides.push(visionItems.slice(i, i + 3));
  }

  return (
    <div className="home-page">
      <AnimatedSection animation="scale-up" duration="slow">
        <section className="">
          <img src="/home_1.jpg" alt="Hero" className="hero-img-large" />
        </section>
      </AnimatedSection>

      <section className="hero-section">
        <div className="hero-container">
          <AnimatedSection animation="fade-left" className="hero-content">
            <h1 className="hero-title">
              Welcome to <span className="highlight">Yolo Production</span>
            </h1>
            <AnimatedSection animation="fade-up" delay={200}>
              <p className="hero-description">
                We believe every photograph tells a story worth remembering. At Yolo Production, we don't just take pictures — we capture emotions, details, and the unique essence of every moment. Whether it's portraits, events, or creative projects, our passion lies in transforming fleeting instants into timeless works of art. With a blend of creativity, professional techniques, and a keen eye for storytelling, we bring your vision to life through the lens.
              </p>
            </AnimatedSection>
            <div className="hero-actions">
            </div>
          </AnimatedSection>
          <AnimatedSection animation="fade-right" delay={300} className="hero-image">
            <div className="hero-placeholder">
              <img src="/home_1.jpg" alt="Hero" className="hero-img" />
            </div>
          </AnimatedSection>
        </div>
      </section>

      <section className="features-section">
        <div className="features-container">
          <AnimatedSection animation="fade-up">
            <h2 className="section-title">Our Visions</h2>
          </AnimatedSection>

          <AnimatedSection animation="fade-up" delay={200}>
            <Carousel
              activeIndex={index}
              onSelect={handleSelect}
              interval={5000}
              className="custom-carousel"
            >
              {slides.map((slideItems, slideIndex) => (
                <Carousel.Item key={slideIndex}>
                  <div className="features-grid">
                    {slideItems.map((item, itemIndex) => (
                      <AnimatedSection
                        key={item.id}
                        animation="bounce-in"
                        delay={(itemIndex * 100) as 100 | 200 | 300}
                        className="feature-card"
                      >
                        <div className="feature-image">
                          <img src={item.image} alt={item.title} className="vision-image" />
                        </div>
                        <div className="feature-content">
                          <div className="feature-icon">
                            <svg width="48" height="48" viewBox="0 0 24 24" fill="currentColor">
                              <path d={item.icon} />
                            </svg>
                          </div>
                          <h3 className="feature-title">{item.title}</h3>
                          <p className="feature-description">{item.description}</p>
                        </div>
                      </AnimatedSection>
                    ))}
                  </div>
                </Carousel.Item>
              ))}
            </Carousel>
          </AnimatedSection>
        </div>
      </section>

      <section className="about-section">
        <div className="about-container">
          <AnimatedSection animation="fade-up" className="about-content">
            <h2 className="about-title">Why Choose Yolo Production?</h2>
            <AnimatedSection animation="fade-up" delay={100}>
              <p className="about-description">
                With years of experience in the photography industry, we understand that every moment is unique and deserves to be captured with precision and artistry. Our commitment to excellence, combined with state-of-the-art equipment and a passion for storytelling, ensures that your memories are transformed into timeless works of art.
              </p>
            </AnimatedSection>
            <div className="about-features">
              <AnimatedSection animation="scale-up" delay={200} className="about-feature">
                <div className="feature-number">200+</div>
                <div className="feature-text">Happy Clients</div>
              </AnimatedSection>
              <AnimatedSection animation="scale-up" delay={300} className="about-feature">
                <div className="feature-number">5+</div>
                <div className="feature-text">Years Experience</div>
              </AnimatedSection>
              <AnimatedSection animation="scale-up" delay={400} className="about-feature">
                <div className="feature-number">100%</div>
                <div className="feature-text">Satisfaction Rate</div>
              </AnimatedSection>
            </div>
          </AnimatedSection>
        </div>
      </section>
    </div>
  );
};

export default HomePage;
